import { Alert, Button, Text } from '@mantine/core';
import { IconAlertCircle, IconLogout } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export const NoAccess = () => {
  const { t } = useTranslation();

  // 退出时跳转到支持网站
  const handleExit = () => {
    const supportWebsite = import.meta.env.VITE_SUPPORT_WEBSITE;
    if (supportWebsite) {
      window.location.href = supportWebsite;
    } else {
      // 如果没有配置支持网站，则跳转到根路径
      window.location.href = '/';
    }
  };
  return (
    <div
      className="flex flex-col items-center justify-center h-screen text-center"
      style={{ backgroundColor: 'rgb(241, 245, 249)' }}
    >
      <Alert
        icon={<IconAlertCircle size={24} stroke={2} className="mt-1" />}
        title={t('no_access.title')}
        color="yellow"
        className="w-2/3 md:w-[500px] mb-6"
        styles={{
          root: { alignItems: 'center' },
          title: { fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.2rem' },
          message: { fontSize: '1rem' },
        }}
      >
        <Text ta="left" c="gray.6">
          {t('no_access.desc')}
        </Text>
      </Alert>
      <div className="mt-2 space-y-4 w-2/3 md:w-[500px]">
        <Button leftSection={<IconLogout size={20} />} variant="filled" fullWidth onClick={handleExit}>
          {t('no_access.exit')}
        </Button>
      </div>
    </div>
  );
};
